import {
  isActivityBuilderSectionAccessible,
  isActivitySectionSaved,
} from "../activityWorkflowUtils";

const ActivityProgressSidebar = ({
  sections,
  sectionStatuses,
  activeSectionId,
  hasActivityId,
  completedUnlockOrder,
  isResumeEdit,
  onSectionClick,
}) => {
  return (
    <nav className="space-y-0.5" aria-label="Activity builder progress">
      {sections.map((item) => {
        const status = sectionStatuses[item.id] || "not_started";
        const isActive = activeSectionId === item.id;
        const isCompleted = isActivitySectionSaved(item.unlockOrder, completedUnlockOrder);
        const locked = !isActivityBuilderSectionAccessible(
          item.unlockOrder,
          completedUnlockOrder,
          hasActivityId,
          isResumeEdit
        );

        return (
          <button
            key={item.id}
            type="button"
            onClick={() => onSectionClick(item.id, item.unlockOrder)}
            aria-current={isActive ? "step" : undefined}
            className={`flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left text-sm transition-all ${
              isActive
                ? "bg-primary/10 font-medium text-primary ring-1 ring-primary/20"
                : locked
                ? "text-gray-400"
                : status === "complete" || isCompleted
                ? "text-emerald-700 hover:bg-emerald-50"
                : status === "incomplete"
                ? "text-amber-700 hover:bg-amber-50"
                : "text-gray-600 hover:bg-gray-50"
            }`}
          >
            <span
              className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[11px] font-bold ${
                isActive
                  ? "bg-primary text-white"
                  : isCompleted
                  ? "border border-emerald-100 bg-emerald-50 text-emerald-600"
                  : "bg-slate-100 text-slate-500"
              }`}
            >
              {isCompleted ? (
                <i className="fi fi-rr-check text-[10px]" />
              ) : (
                item.unlockOrder
              )}
            </span>
            <span className="min-w-0 flex-1">
              <span className="block truncate font-medium">{item.name}</span>
              {!isActive && (
                <span className="mt-0.5 block text-[11px] text-gray-400">
                  {locked ? "Locked" : isCompleted ? "Complete" : "Pending"}
                </span>
              )}
            </span>
            {locked && <i className="fi fi-rr-lock text-xs text-gray-400" />}
          </button>
        );
      })}
    </nav>
  );
};

export default ActivityProgressSidebar;
